import { render, staticRenderFns } from "./ValuesSection.vue?vue&type=template&id=44eb91fd&scoped=true"
import script from "./ValuesSection.vue?vue&type=script&lang=js"
export * from "./ValuesSection.vue?vue&type=script&lang=js"
import style0 from "./ValuesSection.vue?vue&type=style&index=0&id=44eb91fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eb91fd",
  null
  
)

export default component.exports